import {faCommentAlt, faFileLines} from "@fortawesome/free-solid-svg-icons";
import {
  GSButton,
  GSInfoCard,
  GSInfoGroup,
  GSCircleImage,
  golfstatusSpacing,
  golfstatusTypography,
} from "golfstatus_react_components";
import React from "react";

import "./tournament-team-player-card.scss";
import { displayPlayerHandicap } from "../../../helpers/Handicaps";

const TournamentTeamPlayerCard = (props) => {
  const {
    name,
    email,
    avatar,
    signupMessage,
    messageClicked,
    onViewResponses,
    player,
    tournament,
    flag,
  } = props;

  //const defaultAvatar = "https://api.golfstatus.dev/images/user_round.png";

  const avatarInfo = {
    sectionItems: [
      {
        type: "primary",
        value: <GSCircleImage size="xx-large" url={avatar}></GSCircleImage>,
      },
    ],
  };

  const contactInfo = {
    sectionItems: [
      {
        type: "primary no-wrap full-width capitalize",
        value: `${name} ${displayPlayerHandicap(player, tournament)}`,
      },
      {
        type: "secondary nowrap",
        value: email,
      },
    ],
  };

  const actionInfo = {
    sectionItems: [],
  };

  if (flag === "pro") {
    actionInfo.sectionItems.push({
      type: "primary no-wrap full-width",
      value: <GSButton type="secondary pill green" title="Pro" />,
    });
  }

  if (signupMessage) {
    actionInfo.sectionItems.push({
      type: "primary no-wrap full-width",
      value: (
        <GSButton
          type="secondary"
          buttonIcon={faCommentAlt}
          onClick={(e) => {
            messageClicked?.({ ...props });
            e?.stopPropagation?.();
          }}
        />
      ),
    });
  }

  if (player && onViewResponses) {
    contactInfo.sectionItems.push({
      type: "primary no-wrap",
      sectionItemStyle: { paddingTop: golfstatusSpacing.mediumPad },
      value: (
        <GSButton
          type="light-grey no-wrap mobile-icon"
          buttonIcon={faFileLines}
          iconStyle={{ fontSize: golfstatusTypography.smallFont }}
          title="Form Responses"
          onClick={(e) => {
            e?.stopPropagation?.();
            onViewResponses?.(player);
          }}
        />
      ),
    });
  }

  const teamInfo = {
    fit: "stretch",
    sections: [{ ...avatarInfo }, { ...contactInfo }],
  };

  const actions = {
    fit: "additional-info",
    sections: [{ ...actionInfo }],
  };

  const getGroup = () => {
    let group = [{ ...teamInfo }, { ...actions }];
    return group;
  };

  return (
    <tournament-team-player-card>
      <GSInfoCard
        size="large"
        layout={<GSInfoGroup dataGroups={getGroup()}></GSInfoGroup>}
      ></GSInfoCard>
    </tournament-team-player-card>
  );
};

export default TournamentTeamPlayerCard;
